import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';

import { CommunicationMessageService } from '@app-services/communication-message/communication-message.service';
import { ScheduleService } from '@app-services/schedule/schedule.service';
import { ExamService } from '@app-services/test/exam.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { UserService } from '@app-services/user/user.service';
import { TestComingSoonDialogComponent } from '@app-shared/components/test-coming-soon-dialog/test-coming-soon-dialog.component';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';

import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SubscribemodalComponent } from '@app-shared/components/subscribemodal/subscribemodal.component';

import { curTenantDetails, portal, tenant, timeBoundTypes ,PaidSubscribedTest, apisDataCacheKeys} from '@app-constants/app.constants';
import { getDateFromTestSpan, isCurrentTimeGreaterExamEndtime, getCourseName, getExamName } from 'src/app/helpers/functions';
import { environment } from '@app-environments/environment';
import { ClassService } from 'src/app/core/services/class.service';
import { WizklubService } from 'src/app/core/services/wizklub.service';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
export function availableForAttempt(test: any) {
  // let string =test.span;
  // let examstart = moment(string, "YYYY-MM-DD hh:mm A").format("YYYY-MM-DD HH:mm");
  // let current_time = moment().format("YYYY-MM-DD HH:mm");
  // let timeBefore10Min = moment(examstart,'YYYY-MM-DD HH:mm').add(-11, 'minutes').format('YYYY-MM-DD HH:mm');
  // return moment(current_time).isAfter(timeBefore10Min);
  //return timeBefore10Min;
  let string = test.span;
  let examstart = getDateFromTestSpan(string);
  //@ts-ignore
  let timeBefore10Min = new Date(+examstart).setMinutes(examstart.getMinutes() - 10);
  let serverTime = localStorage.getItem('serverTime') + '000';
  let serverTimeNow = Number(serverTime);
  return serverTimeNow > timeBefore10Min;

}
export function availableForAttempt_moment(test: any) { 
  let string = test.span;
  let examstart = getDateFromTestSpan(string);
  let timeBefore10Min =  moment(examstart ).subtract(10,'minutes')
  return moment.utc().isAfter(timeBefore10Min)

}
export function canRegisterTimeChecking(test: any) {
  let string = test?.span;
  let examstart = getDateFromTestSpan(string);
  //@ts-ignore
  let examendDateTimeMinus10Min = new Date(+examstart).setMinutes(examstart.getMinutes() + parseInt(test?.duration) - 10);
  let serverTime = localStorage.getItem('serverTime') + '000';
  let serverTimeNow = Number(serverTime);
  return examendDateTimeMinus10Min > serverTimeNow;
}
export function displayFormatedDateTime(test: any) {
  let string = test.span;
  var checkValidDate = moment(string, "YYYY-MM-DD hh:mm A", true).isValid()
  if(checkValidDate){
  let examstart = moment(string, "YYYY-MM-DD hh:mm A").format("YYYY-MM-DD HH:mm");
  let examendDateTime = moment(examstart, 'YYYY-MM-DD HH:mm').add(parseInt(test?.duration), 'minutes').format('YYYY-MM-DD HH:mm');
  return moment(examstart, 'YYYY-MM-DD HH:mm').format('Do MMMM') + ' (' + moment(examstart, 'YYYY-MM-DD HH:mm').format('h:mm A') + '-' + moment(examendDateTime, 'YYYY-MM-DD HH:mm').format('h:mm A') + ')';
  }else{
    return ''
  }
}

export function attemptTestNow(testInfo: any, examtype: any) {
  // this.examService.setPresentExamInfo(testInfo);
  // this.router.navigateByUrl('/dashboard/testinstructions');
  const testType = Array.isArray(testInfo?.test_type) ?testInfo?.test_type?.[0]:testInfo?.test_type
  const examname = getExamName(testType);
  const coursename = getCourseName(testInfo.exam_type) as any;
  if (examname == 'PREVIOUSYEAR') {
    this.gaService.webEngageEvent({
      'event': 'PYP Attempt Now',
      'Test name': testInfo.schedulename
    })
  } else if (examname == 'MOCKTEST') {
    this.gaService.webEngageEvent({
      'event': 'MCT Attempt Now',
      'Test name': testInfo.schedulename
    })
  } else if (examname == 'SCOREMOCKTEST') {
    this.gaService.webEngageEvent({
      'event': 'score_mock_attempt_now',
      'test_name': testInfo?.schedulename
    })
  }
  this.testListService.isUserSubscribed(examname, testInfo, 'attempt').then((resp: any) => { 
    const isTimeBoundTestType = timeBoundTypes.indexOf(examname) > -1;
    if (curTenantDetails['subscriptions'] && !(testInfo['resume'] && testInfo['resume'] === true)) {
// ['New NEET Mock Test', 'MOCKTEST','RAPTimeBound','RAPDailyTest','67521','New NEET Timebound']
      if (resp && PaidSubscribedTest.indexOf(examname.toUpperCase()) > -1) {
        var componentInstance = this.modalservice.open(SubscribemodalComponent, {
          centered: true, size: 'sm', windowClass: 'subscription-modal-custom'
        })
        this.spinner.hide()
        return;
      }
    }
    if (!(testInfo['resume'] && testInfo['resume'] === true) && (coursename.replaceAll(" ", "").toUpperCase() == "JEEADVANCED" || coursename.replaceAll(" ", "").toUpperCase() == "NTSE")) {
      if ((Number(testInfo?.noofpapers) || 1) > 1) {
        if ( Number(testInfo?.papernum) != 1) {
          // let testsByScheduleId: any = {};
          // if (this?.infobox?.testLists) {
          //   this.infobox.testLists.forEach(test => {
          //     if (!testsByScheduleId[test.scheduleid]) {
          //       testsByScheduleId[test.scheduleid] = [];
          //     }
          //     testsByScheduleId[test.scheduleid].push(test);
          //   });
          // } else if (this.testsByScheduleId) {
          //   testsByScheduleId = this.testsByScheduleId
          // } else {
          //   return;
          // }
          // const otherTest = testsByScheduleId[testInfo.scheduleid][0]._id != testInfo._id ? testsByScheduleId[testInfo.scheduleid][0] : testsByScheduleId[testInfo.scheduleid][1];
          let similarschedules = [...this.testListService.getUSerExamlist.ongoingTests.filter(v=>v?.subruleid == testInfo?.subruleid),...this.testListService.getUSerExamlist.upcomingTests.filter(v=>v?.subruleid == testInfo?.subruleid) ]
          const otherTest = similarschedules.find(v=>v.papernum < testInfo.papernum )
          // if ((!otherTest?.testtaken) && testsByScheduleId[testInfo.scheduleid][0]._id != testInfo._id) {
          if (otherTest && otherTest?._id != testInfo?._id && (otherTest?.availableForAttempt ||otherTest?.isExamInProgress)) {
            alert(`You can't attempt Paper ${testInfo?.papernum} without completing Paper ${testInfo?.papernum-1}`);
            return;
          }
        }
      }
    }
    {
      if (!this.attemptNowCLicked) {
        if (examname === 'PREVIOUSYEAR' || examname === 'TIMEBOUND') {
          this.attemptNowCLicked = true
          const typeShortName = examname === 'PREVIOUSYEAR' ? 'pyp' : (this.tenant == 'srichaitanya' ? "SCTS" : "ILTS");
          const actionName = testInfo['resume'] && testInfo['resume'] === true ? "resume" : 'attempt';
          this.gaService.sendEvent(
            `${typeShortName}_${actionName}_now`,
            `${typeShortName}_dashboard`,
            `${typeShortName}_${actionName}_now`,
            `${actionName}_now`,
          );
        }
      }

      let exam_meta_data: any = localStorage.getItem('exam_meta_data');
      if (exam_meta_data) {
        localStorage.removeItem('exam_meta_data');
      }
      console.log(testInfo);
      this.examService.setPresentExamInfo(testInfo);
      this.router.navigateByUrl('/dashboard/testinstructions');
    }
  });
}

export function comingSoon(test: any) {
  let dialogRef = this.dialog.open(TestComingSoonDialogComponent, {
    panelClass: 'ASM_ib_minh_260',
    width: '500px',
    data: {
      scheduledTime: displayFormatedDateTime(test)
    }
  });
}

export function attemptTestNowSCTB(test: any, examtype: any) {
  if (!this.availableForAttempt(test)) {
    this.comingSoon(test);
  } else {
    localStorage.removeItem('examInfoFromCourseAssignmentScreen')
    this.attemptTestNow(test, examtype)
  }
}

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.css']
})
export class InfoBoxComponent implements OnInit {
  token: any;
  tenant: any = tenant;
  portal: any = portal;
  attemptNowCLicked: any = false;
  @Input() infobox: any;
  @Input() latestTimeboundTest: any;
  @Input() examName: any;
  @Output() testRegister: EventEmitter<any> = new EventEmitter();
  @Input() type: string;
  @Input() index: number;
  @Output() upcmingNotPresent: EventEmitter<any> = new EventEmitter();
  freeExamcount: any = {
    'New NEET Timebound': 1,
    'New NEET Mock Test': 2,
    'MOCKTEST': 2,
    'TIMEBOUND': 1,
    // 'CYOT,67521':2
  }
  isCurrentTimeGreaterExamEndtime = isCurrentTimeGreaterExamEndtime;
  availableForAttempt = availableForAttempt;
  canRegisterTimeChecking = canRegisterTimeChecking;
  displayFormatedDateTime = displayFormatedDateTime;
  attemptTestNow = attemptTestNow;
  attemptTestNowSCTB = attemptTestNowSCTB;
  comingSoon = comingSoon;
  curTenantDetails = curTenantDetails;
  attemptedNumber: any = 0;
  totalCount: any = 0;
  completedCount: any = 0;
  isTimeBoundTestType: boolean = false;
  isNeetNewPattern: boolean = false;
  isSubscribed:boolean = true;
  public info_box_class =''
  wizKlubToken: any=environment.wizclienttooken;
  wizKlubBaseUrl:any = environment.wizKlubBase
  redirectWiz: string;
  // redirectWiz: string;
  constructor(private examService: ExamService,
    private testListService: TestlistService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private gaService: GAnalyticsService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private scheduleService: ScheduleService,
    private communicationMessageService: CommunicationMessageService,
    public modalservice: NgbModal,
    private eventHandlingService:EventHandlingService,
    private wizService:WizklubService
  ) {
    this.token = localStorage.getItem('token')
  }

  ngOnChanges(changes: any) {
    // if(changes && changes.infobox.currentValue.testLists){
    //   this.infobox = changes.infobox.currentValue;
    //   if(this.infobox.testLists.length > 0) {this.checkIfUserSubscribed()} else {this.isSubscribed = true}
    // }
  }

  ngOnInit(): void {
    // console.log(this.infobox);
    this.isNeetNewPattern = this.infobox.examtype == 'New NEET Mock Test' || this.infobox.examtype == 'New NEET Timebound';
    this.isTimeBoundTestType = timeBoundTypes.indexOf(this.infobox.examtype) > -1;
    this.colorBox();
    // if(this.infobox?.testLists?.length > 0) {this.checkIfUserSubscribed()};
  }

  getParameterByName(name: any, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  registerNow(test: any) {
    let tests: any = [];
    const examname = getExamName(test.test_type[0]);
    if (examname == "SCHOLARSHIPTEST") {
      this.gotoList()
      return;
    }
    if (this.infobox.examname == "JEEADVANCED") {
      tests = this.infobox.testLists.filter(t => test.scheduleid == t.scheduleid);
      if (tests.length < (Number(test?.noofpapers) || 99999)) return;
    } else {
      tests = [test];
    }
    this.testRegister.emit({ tests, examtype: this.infobox.examtype })
  }

 async gotoList(e?: any) {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    this.sendWebevent()
    localStorage.setItem("shortname",this.infobox.shortname)
    if(this.infobox.shortname !="WIT"){
      this.router.navigateByUrl(this.infobox.link.route);
    }else{
     await this.generateWizToken()
    }
  }

  checkUpcomingAvailble() {
    this.upcmingNotPresent.emit();
  }

  // checkIfUserSubscribed() {
  //   if (this.infobox.examtype == "ILTS" || this.infobox.examtype == "TIMEBOUND" || this.infobox.examtype == "New NEET Timebound" || this.infobox.examtype == "New NEET Mock Test" || this.infobox.examtype == "MOCKTEST") {// || examtype == "SCHOLARSHIPTEST"){
  //     this.testListService.isUserSubscribed(this.infobox.examtype, this.infobox.testLists[0], 'attempt').then((resp: any) => { 
  //     if(!resp) this.isSubscribed =  true; else  this.isSubscribed = false;
  //     })
  //   }
  // }
  colorBox(){
    console.log("🚀 ~ file: info-box.component.ts:298 ~ colorBox ~ this.infobox.examtype:", this.infobox.examtype)
    if(this.infobox.examtype == 'GRANDTEST'){
      this.info_box_class ='yellow' 
    }else if(['New NEET Timebound','TIMEBOUND','PREVIOUSYEAR',"71dd90e4-65be-11ed-9022-0242ac120002","0ed6411c-65be-11ed-9022-0242ac120002","1eda50ee-65be-11ed-9022-0242ac120002","7dfddc62-65be-11ed-9022-0242ac120002","a132a744-65be-11ed-9022-0242ac120002","a851d6b8-65bd-11ed-9022-0242ac120002","afa94d8c-65be-11ed-9022-0242ac120002","d0e5c8fa-65bd-11ed-9022-0242ac120002"].indexOf(this.infobox.examtype)  !== -1){
      this.info_box_class ='blue' 
    }else if(['New NEET Mock Test','MOCKTEST',"337edf2e-65be-11ed-9022-0242ac120002","41d60246-65be-11ed-9022-0242ac120002","52d43478-65be-11ed-9022-0242ac120002","6649791e-65be-11ed-9022-0242ac120002",].indexOf(this.infobox.examtype) !== -1 ){
        this.info_box_class ='red' 
    }else if( ['CYOT,67521',"CYOT","53355d15-4a4a-4df8-a881-688c43f0c65e"].indexOf(this.infobox.examtype) !== - 1 ){
        this.info_box_class ='purple';
    }else if(this.infobox?.shortname == 'WIT') {
        this.info_box_class ='red-orange';
    }
  }
  sendWebevent(){
    if (this.infobox.examtype == "ILTS" || this.infobox.examtype == "TIMEBOUND" || this.infobox.examtype == "New NEET Timebound") {
      const key = this.infobox.examtype == "New NEET Timebound" ? "_new_pattern" : "";
      const testType = this.tenant == 'srichaitanya' ? ("SCTS" + key) : ("ILTS" + key);
      this.gaService.sendEvent(
        `${testType}_OPEN_LIST`,
        `${testType}_dashboard`,
        `${testType}_OPEN_LIST`,
        'open_list',
      );
    }
    var examConversion={
      "PREVIOUSYEAR":'PYP Exam Started',
      'MOCKTEST':'MCT Started',
      'TIMEBOUND': 'ILTS test Started',
      'SCOREMOCKTEST':"score_mock_exam_started"
    }    
      this.gaService.webEngageEvent({
        'event': examConversion[this.infobox.examtype],
        'total': this.infobox.paper.totaltests,
        'free ': (this.freeExamcount[this.infobox.examtype] == undefined) ? 0 : this.freeExamcount[this.infobox.examtype]
      })    
  }

  generateWizToken(){
    let userdetails = JSON.parse(localStorage.getItem('user_details_from_server'));
    const details = userdetails?.exams || [];
    const uamExamId = details.find(e => e.name.replaceAll(' ', '')?.toUpperCase() === localStorage.getItem('targetExamName'))?.examId;
    const WITCardClickedEvent = {
      'event': 'wit_card_clicked',
      "page url": window.location.href,
      'First Name': userdetails.firstName,
      'Last Name': userdetails.lastName,
      'Grade': userdetails?.grade?.gradeId,
      'Exam': uamExamId,
    };
    this.gaService.webEngageEvent(WITCardClickedEvent);
    let body = {
      username : String(userdetails?.userId),
      difficulty : Number(userdetails?.grade?.name?.replace(/[^0-9]/g, '')),
      name : `${userdetails.firstName} ${userdetails.lastName}`
    }
    console.log(body, WITCardClickedEvent);
    let headers = {
      'Wiz-Client-Token':this.wizKlubToken,
      'Content-Type': 'application/json',
      "Accept":'*/*',
      'Connection':'Keep-alive',
      'Accept-Encoding':'gzip, deflate, br',
    }
    this.wizService.generateWizKlubToken(body, headers)
      .then((res) => res.json())
      .then((res:any)=>{
        console.log(res);
        this.wizKlubToken = res?.response?.token;
        this.redirecttoAssessment()
      }).catch( (err)=>{
        console.log(err)
        // await this.generateWizToken()
      })
  }

  redirecttoAssessment(){
    if(this.wizKlubToken){
      let user: any = localStorage.getItem(apisDataCacheKeys.userDetails);
      user = localStorage.getItem(apisDataCacheKeys.userDetails)
        ? JSON.parse(user)
        : {};
      const gradeNo = user?.grade?.name?.replace(/[^0-9]/g,'');
      const payload = {
        "firstName": user?.firstName,
        "phone": user?.phone,
        "lastName": user?.lastName,
        "userId": user?.userId,
        "gradeId": gradeNo
      }
      const ILAccessToken: any = localStorage.getItem('token');
      this.testListService.getTokenAPI(payload).subscribe((res) => {
        this.redirectWiz = `${this.wizKlubBaseUrl}/infinitylearn/login/?access_token=${this.wizKlubToken}&page=assessment&product_id=11a6c8ca-2311-4e23-bde2-e9845df54767&platform=web&userToken=${res?.access_token}&IlAccessToken=${ILAccessToken}`
        this.eventHandlingService.redirectToWiz({ event: this.redirectWiz });
        //  this.router.navigateByUrl(this.infobox.link.route);
        window.location.href = this.redirectWiz
      })
    }
  }

}
